module.exports = __webpack_public_path__ + "static/img/IMG(5).c501c9c2.jpg";